import React, { useState, useEffect } from "react";
import { Button, Space, Table, notification, Tooltip, Form, Tabs } from "antd";
import style from "./index.module.scss";
import classNames from "classnames/bind";
import { useTranslation } from "react-i18next";
import FormFilter from "./components/FormFilter";
import userEventApi from "api/userEvent";
import * as XLSX from 'xlsx';
import { toast } from "react-toastify";
import { areaTabs } from "constants/index";
import ModalDelete from "./components/ModalDelete";
import { UndoOutlined } from "@ant-design/icons";

const cx = classNames.bind(style);
export default function ListConfirmQr() {
  const [formSearch] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();

  const { t } = useTranslation();

  const [tab, setTab] = useState("1");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({ message, description, duration: 30 });
  };

  const columns = [
    {
      title: t('departmentManager'),
      dataIndex: "areaManager",
      key: "areaManager",
    },
    {
      title: t('code'),
      dataIndex: "code",
      key: "code",
    },
    {
      title: t('firstName'),
      dataIndex: "firstName",
      key: "firstName",
    },
    {
      title: t('lastName'),
      dataIndex: "lastName",
      key: "lastName",
    },
    {
      title: t('join'),
      dataIndex: "join",
      key: "join",
      render: (_, record) => record?.isConfirmQr ? 'X' : ''
    },
    {
      title: t('unregistered'),
      dataIndex: "unregistered",
      key: "unregistered",
      render: (_, record) => !record?.isConfirmQr ? 'X' : ''
    },
    {
      title: t('action'),
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <ModalDelete
          row={record}
          onSearch={fetchUser}
          openNotificationWithIcon={openNotificationWithIcon}
        />
      )
    },
  ]

  const fetchUser = async () => {
    try {
      setLoading(true)
      const res = await userEventApi.getAll({
        areaManager: formSearch.getFieldValue('areaManager'),
        code: +formSearch.getFieldValue('code') || undefined,
        firstName: formSearch.getFieldValue('firstName'),
        lastName: formSearch.getFieldValue('lastName'),
        area: tab,
        unregistered: formSearch.getFieldValue('unregistered'),
      });
      setData(res.userEvent || [])
    } catch (error) {
      console.log("🚀 ~ error:", error)
    } finally {
      setLoading(false)
    }
  }

  const handleResetAll = async () => {
    try {
      await userEventApi.resetAllQr();
      fetchUser();
      openNotificationWithIcon("success", t('notification'), t('success'));
    } catch (error) {
      openNotificationWithIcon("error", t('error'), error?.response?.data?.message || t('hasError'));
    }
  };

  const onChangeTab = (key) => {
    setTab(key)
  }

  useEffect(() => {
    fetchUser()
  }, [tab])

  return (
    <div className={cx("page-sushi")}>
      {contextHolder}
      <div className={cx("title")}>
        <p>{t("listEmployee")}</p>
      </div>
      <Tabs
        activeKey={tab}
        type="card"
        items={areaTabs.map(item => ({
          ...item,
          disabled: loading,
        }))}
        onChange={onChangeTab}
      />
      <FormFilter loading={loading} form={formSearch} submit={fetchUser} />
      <Button size="large" icon={<UndoOutlined />} onClick={handleResetAll} loading={loading}>
        {t('resetAll')}
      </Button>
      <br />
      <br />
      <Table
        loading={loading}
        columns={columns}
        dataSource={data}
        bordered
        pagination={false}
        sticky
        summary={(pageData) => {
          return (
            <Table.Summary fixed>
              <Table.Summary.Row className={cx('')}>
                <Table.Summary.Cell index={0} align="left" className="cell-total">
                  <b>{t('sum')}</b>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} colSpan={3} align="left" className="cell-total">
                  <b>{pageData.length}</b>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} align="left" className="cell-total">
                  <b>{pageData.reduce((total, item) => total + (item.isConfirmQr ? 1 : 0), 0)}</b>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} align="left" className="cell-total">
                  <b>{pageData.reduce((total, item) => total + (!item?.isConfirmQr ? 1 : 0), 0)}</b>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          )
        }}
      />
    </div >
  );
}
